// eslint-disable-next-line unicorn/prefer-module
module.exports = function getPort(request) {
  const {
    headers: { 'x-forwarded-port': port = request.port } = {},
  } = request;

  return Number(port);
};
